import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "shared/cubiq-services";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupAcceptanceTransferNotificationData extends BfxPopupNotificationData {
  public acceptanceState: BfxBlotterOrdersContextMenuItemAcceptanceState;

  constructor(private activeUser: CubiqServices.ActiveUser, private hasTransfer: boolean) {
    super(
      BFXNotificationType.ACCEPTANCE_NEEDED,
      "icon-bfx_arrow_right",
      BFXNotificationSubType.ACCEPTANCE_TRANSFER,
    );
    this.acceptanceState = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.acceptanceState.actionRequests = {
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      acceptInto: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      reject: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.acceptanceState.actionRequests.accept.acceptance.clear();
    this.acceptanceState.actionRequests.accept.xfer.clear();
    this.acceptanceState.actionRequests.acceptInto.acceptance.clear();
    this.acceptanceState.actionRequests.acceptInto.xfer.clear();
    this.acceptanceState.actionRequests.reject.acceptance.clear();
    this.acceptanceState.actionRequests.reject.xfer.clear();
  }

  private addToAcceptMap(traderGroup: string, orderId: string) {
    if (!this.acceptanceState.actionRequests.accept.xfer.has(traderGroup)) {
      this.acceptanceState.actionRequests.accept.xfer.set(traderGroup, []);
    }
    this.acceptanceState.actionRequests.accept.xfer.get(traderGroup).push(orderId);
  }
  private addToAcceptIntoMap(traderGroup: string, orderId: string) {
    if (!this.acceptanceState.actionRequests.acceptInto.xfer.has(traderGroup)) {
      this.acceptanceState.actionRequests.acceptInto.xfer.set(traderGroup, []);
    }
    this.acceptanceState.actionRequests.acceptInto.xfer.get(traderGroup).push(orderId);
  }
  private addToRejectMap(traderGroup: string, orderId: string) {
    if (!this.acceptanceState.actionRequests.reject.xfer.has(traderGroup)) {
      this.acceptanceState.actionRequests.reject.xfer.set(traderGroup, []);
    }
    this.acceptanceState.actionRequests.reject.xfer.get(traderGroup).push(orderId);
  }

  protected updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    if (this.activeUser.userTypeId === CubiqTS.UserType.TRADER && this.hasTransfer) {
      let acceptCount: number = 0;
      let acceptIntoCount: number = 0;
      let rejectCount: number = 0;

      this.payload.forEach((item) => {
        if (this.activeUser.tradingGroupsIds.indexOf(`${item.as_fv_targetDeskId}`) > -1) {
          acceptCount++;
          rejectCount++;
          acceptIntoCount++;
          this.addToAcceptMap(item.as_fv_targetDeskId, item.orderId);
          this.addToAcceptIntoMap(item.as_fv_targetDeskId, item.orderId);
          this.addToRejectMap(item.as_fv_targetDeskId, item.orderId);
        }
      });

      if (acceptCount == this.payload.length) {
        this.actions.push({
          label: "Accept",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (acceptIntoCount == this.payload.length) {
        this.actions.push({
          label: "Accept Into",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT_INTO,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (rejectCount == this.payload.length) {
        this.actions.push({
          label: "Reject",
          command: BfxPopupNotificationCommand.POPUP_DI_REJECT,
          icon: "fa icon-menu-error bfx-context-menu-icon",
          styleClass: "bfx-context-menu-item-enabled",
          separatorBefore: this.actions.length > 0,
        });
      }
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }
}
